// METIS Hub wording — namespace "people" (en), 372 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/people.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const people: Record<string, string> = {
  "people.list.teamFilterReset": "The selected team is protected as a small group. Showing all permitted teams.",
  "people.kicker.all": "Company-wide",
  "people.kicker.allTeam": "Everyone · {team} only",
  "people.kicker.team": "My team · {team}",
  "people.title.all": "People & teams · company-wide",
  "people.title.team": "{team} people & teams",
  "people.desc": "{range} · Korea time · as of {asof}",
  "people.thisMonth": "This month",
  "people.thisMonth.title": "Change the period to {from} through today",
  "people.invite.btn": "Invite people",
  "people.rule.title": "Shown by team at the time of each record",
  "people.rule.team": "People who moved teams show only the records from while they were on your team. Records of other managers, admins and content reviewers on the team aren’t shown{ex}.",
  "people.rule.teamEx": " ({n|person|people} now)",
  "people.rule.filter": "Picking a team gathers only records made while people were on it. People who left show earlier records only; people who joined show later records only.",
  "people.me.title": "People & teams are viewed in the “{scope}” scope",
  "people.me.body": "Your view scope is “Me”, so other people’s records aren’t shown. Change the scope to compare teams and people.",
  "people.me.to": "View as “{scope}”",
  "people.me.self": "Open my details",
  "people.noTeam.title": "You don’t have access to this team",
  "people.noTeam.desc": "Your current role ({role}) can only view the teams you manage ({mine}). Ask an admin if you need {team} records.",
  "people.noTeam.back": "View my team",
  "people.tabs.label": "People & teams views",
  "people.tab.teams": "Teams",
  "people.tab.people": "People",
  "people.tab.invite": "Invites",
  "people.tab.service": "Service accounts",
  "people.teams.q": "How much does each team use?",
  "people.teams.tech": "{metric} · by name (not a ranking) · CLI solid / API hatched",
  "people.teams.sum": "{u|person|people} in {n|team|teams} used AI in this period.",
  "people.teams.row": "active {a}/{m} · {p|question|questions}",
  "people.teams.rowSmall": "{t|team|teams} · active {a}/{m} · {p|question|questions}",
  "people.teams.hiddenTech": "{teams} · {n|person|people} · small-group protection",
  "people.teams.hiddenSum": "The team you picked has fewer than 3 people, so team values are hidden. With all teams, it shows inside the “Small teams combined” row.",
  "people.teams.allTeams": "View all teams",
  "people.teams.small": "Small teams combined",
  "people.teams.smallNote": "Teams under 3 people are combined into one “Small teams combined” row. If only one team is combined or it is still under 3 people, that row’s values are hidden too.",
  "people.teams.rowSmallHidden": "Teams under 3 combined · still under 3, so values are hidden",
  "people.teams.opt.metric": "Metric",
  "people.teams.opt.periodHelp": "Changing the period changes it for the whole People screen.",
  "people.teams.col.team": "Team",
  "people.teams.col.members": "People",
  "people.teams.col.active": "Active",
  "people.teams.col.prompts": "Questions",
  "people.teams.col.tokens": "Usage",
  "people.teams.col.sessions": "Conversations",
  "people.teams.toPeople": "See people on {team}",
  "people.empty.next30": "Widen to 30 days",
  "people.ratio.q": "What share is CLI tools vs API key calls on each team?",
  "people.ratio.tech": "Share by how used · 100% bars · CLI solid / API hatched",
  "people.ratio.sum": "{p} of usage is CLI tools.",
  "people.ratio.sumCount": "{p} of questions and calls are CLI tools.",
  "people.ratio.tokens": "Usage (tokens)",
  "people.ratio.count": "Questions & calls",
  "people.ratio.none": "No records in this period",
  "people.cost.q": "How is cost split across teams?",
  "people.cost.tech": "By cost kind · never added together · not a bill",
  "people.cost.sum": "CLI tool estimates are {a} and price-table costs are {b}. They are different kinds, so they aren’t added together.",
  "people.cost.col.cli": "CLI tool estimate",
  "people.cost.col.unofficial": "Codex unofficial",
  "people.cost.col.gw": "Price table",
  "people.cost.col.org": "Org report",
  "people.cost.orgNote": "Org reports follow the API keys each team owns · billing basis · daily · not per person",
  "people.cost.mobileNote": "Codex unofficial and org report costs show on wider screens.",
  "people.list.q": "How much does each person use?",
  "people.list.tech": "Questions & usage · {period} · {sort}",
  "people.list.sum": "{a} of {n} people used AI in this period.",
  "people.list.sumConn": "{b|person has|people have} connections to check.",
  "people.list.sumFormer": "{f|person|people} who moved to another team are shown with their earlier records.",
  "people.list.sumSmall": "Fewer than 3 people have records, so per-person values are hidden.",
  "people.list.sumFiltered": "Showing {n|person|people} matching your conditions.",
  "people.list.none": "No one matches these conditions.",
  "people.list.noneNot": "Clear the search or loosen the conditions.",
  "people.list.clear": "Clear conditions",
  "people.list.range": "{from}–{to} of {n}",
  "people.pager": "People list pages",
  "people.sort.label": "Sort",
  "people.sort.name": "By name",
  "people.sort.tokens": "By usage",
  "people.sort.cost": "By cost",
  "people.sort.byName": "by name (not a ranking)",
  "people.sort.byValue": "by value (not a ranking)",
  "people.sort.off": "Sorting by value is off (recording policy · off by default). It keeps people from being lined up.",
  "people.sort.offLink": "Open recording policy",
  "people.sort.offTip": "Turn on “Allow sorting people by value” in the recording policy",
  "people.sort.scopeTip": "This metric cannot be sorted because of viewing scope or small-group protection",
  "people.sort.on": "Sorted by value. Not a ranking — these numbers are for cost and security management. Cost uses the CLI tool estimate.",
  "people.search.label": "Find people",
  "people.search.ph": "Search by name, team or role",
  "people.filter.label": "Conditions",
  "people.filter.attention": "Only people with connections to check",
  "people.col.name": "Name",
  "people.col.role": "Role",
  "people.col.team": "Team",
  "people.col.use": "Questions & usage",
  "people.col.cost": "Estimated cost",
  "people.col.tool": "Main tool",
  "people.col.last": "Last used",
  "people.col.conn": "Connection",
  "people.row.prompts": "{n|question|questions}",
  "people.row.noUse": "No records in this period",
  "people.row.never": "No records",
  "people.row.former": "Moved to {team} on {date} · earlier records only",
  "people.row.joined": "Joined on {date} · later records only",
  "people.row.nowTeam": "Now on {team}",
  "people.rule.more": "What can managers see?",
  "people.d.api.keysHidden": "Owns {n|API key|API keys} · aliases and last 4 characters need the key view permission.",
  "people.row.disabled": "Deactivated",
  "people.row.reconsent": "Consent renewal needed",
  "people.row.paused": "Paused",
  "people.row.pending": "Awaiting approval",
  "people.row.noConn": "No connections",
  "people.row.moreConn": "+{n} more",
  "people.row.audit": "Access & change log",
  "people.row.select": "Select {name}",
  "people.row.selectAll": "Select everyone shown",
  "people.cost.cli": "CLI est.",
  "people.cost.gw": "Price table",
  "people.cost.unofficial": "Codex unofficial",
  "people.cost.none": "No cost in this period",
  "people.legend.note": "Bar length is usage (tokens). CLI tools are solid, API key calls are hatched.",
  "people.mobileAdmin": "Invite people and change roles, teams or status on a computer.",
  "people.bulk.label": "Bulk actions",
  "people.bulk.count": "{n} selected",
  "people.bulk.role": "Change role",
  "people.bulk.team": "Move team",
  "people.bulk.disable": "Deactivate",
  "people.bulk.enable": "Reactivate",
  "people.bulk.clear": "Clear selection",
  "people.bulk.teamOff": "You can’t move people outside your delegated teams",
  "people.role.title": "Change role",
  "people.role.kicker": "{n|person|people}",
  "people.role.pick": "New role",
  "people.role.expiry": "Expires on",
  "people.role.expiryHint": "Roles that can view text must have an expiry date.",
  "people.role.reason": "Reason",
  "people.role.reasonPh": "e.g. Appointed Platform manager (reorg)",
  "people.role.reasonHint": "Changes that need two-person approval need at least 10 characters.",
  "people.role.preview": "Who gets what?",
  "people.role.out.now": "Changes now",
  "people.role.out.dual": "Needs two-person approval · {perm} ({scope})",
  "people.role.out.same": "Already has this role",
  "people.role.out.self": "You can’t change your own role",
  "people.role.out.lastAdmin": "The last admin can’t be changed",
  "people.role.out.higher": "Has broader permissions than you",
  "people.role.out.scope": "Outside your delegated teams",
  "people.role.out.perm": "You can’t manage people",
  "people.role.out.disabled": "Deactivated",
  "people.role.rules": "You can’t raise your own permissions and can only grant within your own scope. Adding text, name or export permissions needs two-person approval and updates the notice’s “Who can view”.",
  "people.role.session": "Their sign-in restarts after the change.",
  "people.role.apply": "Change",
  "people.role.err.reason": "Changes that need two-person approval need a reason of at least 10 characters.",
  "people.role.err.none": "No one here can be changed.",
  "people.role.err.expiry": "Pick an expiry date.",
  "people.role.done": "Changed the role for {n|person|people}. Their sign-in restarts.",
  "people.role.doneDual": "{n|person is|people are} waiting for two-person approval (requester and approver must differ).",
  "people.team.title": "Move team",
  "people.team.pick": "New team",
  "people.team.when": "Applies from today ({date}).",
  "people.team.rule": "Team-at-the-time rule: records before the move stay with the old team’s manager, records after it go to the new team’s manager. Past records keep their team.",
  "people.team.apply": "Move",
  "people.team.same": "Already on this team",
  "people.team.done": "Moved {n|person|people} to {team}. Managers’ view changes right away.",
  "people.disable.title": "Deactivate {n|person|people}?",
  "people.disable.b1": "Sign-in and every connection token are blocked right away.",
  "people.disable.b2": "Records stay for the retention period. Deleting them is a separate deletion request.",
  "people.disable.b3": "You can reactivate later, but tools must be connected again.",
  "people.disable.apply": "Deactivate",
  "people.disable.done": "Deactivated {n|person|people} and revoked {k|connection token|connection tokens}.",
  "people.enable.title": "Reactivate {n|person|people}?",
  "people.enable.b1": "They can sign in again. Revoked connection tokens don’t come back.",
  "people.enable.apply": "Reactivate",
  "people.enable.done": "Reactivated {n|person|people}. Tools must be connected again.",
  "people.inv.title": "Invite people",
  "people.inv.kicker": "Invite code",
  "people.inv.email": "Work email",
  "people.inv.emailPh": "name@example.com",
  "people.inv.emailHint": "Only addresses on the allowed domain (example.com) can be invited.",
  "people.inv.team": "Team",
  "people.inv.teamHint": "People belong to teams. Groups (which hold teams) can’t be picked.",
  "people.inv.noTeam": "There’s no team people can join yet.",
  "people.inv.noTeam.groups": "Groups hold teams and can’t take people: {groups}. Turn a group into a regular team, or create a team under it.",
  "people.inv.noTeam.none": "No teams yet. Create a team first.",
  "people.inv.noTeam.ask": "You can’t create or change teams. Ask an administrator to set up teams.",
  "people.inv.noTeam.ungroup": "Make ‘{team}’ a regular team",
  "people.inv.noTeam.tree": "Go to team structure",
  "people.inv.noTeam.ungrouped": "‘{team}’ is now a regular team and can be picked.",
  "people.inv.role": "Starting role",
  "people.inv.roleVal": "Member (default for invites and auto sign-up)",
  "people.inv.roleHint": "Give other roles with “Change role” after they join.",
  "people.inv.make": "Make invite code",
  "people.inv.err.email": "That email address doesn’t look right.",
  "people.inv.err.domain": "Only addresses on the allowed domain (example.com) can be invited.",
  "people.inv.err.dup": "This address was already invited or has joined.",
  "people.inv.done.title": "Invite code ready",
  "people.inv.done.lead": "Send this code to {email}. It’s shown only this once.",
  "people.inv.done.exp": "Valid for 7 days, until {date} · they start as a Member.",
  "people.inv.done.next": "On first sign-in they pick a recording level and connect their tools.",
  "people.inv.toast": "Invite code made. Track it on the Invites tab.",
  "people.inv.paths": "Ways an account is created: made by an admin (temporary password) · invite code · first Google sign-in (Member, allowed domain).",
  "people.invTab.q": "Have the people you invited joined?",
  "people.invTab.tech": "Invite codes · valid 7 days · {scope}",
  "people.invTab.sum": "{p} waiting · {a} joined · {e} expired or canceled.",
  "people.invTab.col.email": "Email",
  "people.invTab.col.team": "Team",
  "people.invTab.col.role": "Starting role",
  "people.invTab.col.by": "Invited by",
  "people.invTab.col.sent": "Sent",
  "people.invTab.col.exp": "Expires",
  "people.invTab.col.status": "Status",
  "people.invTab.col.act": "Actions",
  "people.inv.st.pending": "Waiting",
  "people.inv.st.accepted": "Joined",
  "people.inv.st.expired": "Expired",
  "people.inv.st.canceled": "Canceled",
  "people.inv.resend": "Resend",
  "people.inv.cancel": "Cancel",
  "people.inv.resent": "Made a new code and sent it again (7 days).",
  "people.inv.canceled": "Invite canceled. That code no longer works.",
  "people.inv.code": "Code {code}",
  "people.inv.acceptedAt": "Joined {date}",
  "people.invTab.empty": "No invites sent.",
  "people.invTab.emptyNot": "Without an invite, people on the allowed domain can still join with a first Google sign-in.",
  "people.svc.q": "Which accounts aren’t people?",
  "people.svc.tech": "Service accounts · owner, purpose, expiry, dedicated token",
  "people.svc.sum": "{n|service account|service accounts} · the earliest expiry is {date} ({name}).",
  "people.svc.col.name": "Name",
  "people.svc.col.purpose": "Purpose",
  "people.svc.col.owner": "Owner",
  "people.svc.col.team": "Team",
  "people.svc.col.token": "Dedicated token",
  "people.svc.col.exp": "Expires",
  "people.svc.col.last": "Last used",
  "people.svc.col.status": "Status",
  "people.svc.note": "Not a person. Usage shows to the owner, and service accounts aren’t subject to consent.",
  "people.svc.manage": "Create or extend them on the Roles & permissions screen.",
  "people.svc.left": "{d|day|days} left",
  "people.svc.empty": "No service accounts.",
  "people.svc.emptyNot": "When an internal app or CI calls AI, connect it as a service account instead of a person.",
  "people.conn.q": "Does anyone’s connection need a look?",
  "people.conn.tech": "Connection status · error → not connected → quiet",
  "people.conn.sum": "Check {b} of {n|connection|connections} (error {p} · not connected {d} · quiet {q}).",
  "people.conn.sumOk": "All {n|connection is|connections are} sending fine.",
  "people.conn.more": "{n|more connection|more connections} not shown.",
  "people.conn.idle": "No records for over 3 days shows as “Not connected”. Fine if they didn’t use it.",
  "people.conn.last": "last received {rel}",
  "people.conn.go": "Open in Connect tools",
  "people.conn.none": "No tools connected.",
  "people.d.navTitle": "Person details",
  "people.d.kicker": "Person details",
  "people.d.q": "How does this person use AI?",
  "people.d.view.title": "Opening this screen is logged and shown to the person",
  "people.d.view.body": "Logged as an “Individual view” in the access & change log ({time}). The person sees the viewer’s role and time in “Who viewed my records”.",
  "people.d.view.self": "These are your own details. Viewing your own records isn’t logged.",
  "people.d.moved.title": "Moved to {team} on {date}",
  "people.d.moved.body": "Under the team-at-the-time rule, only records from while they were on {old} (until {until}) are shown. Their current connections and recording level aren’t.",
  "people.d.joined.title": "Joined from {old} on {date}",
  "people.d.joined.body": "Under the team-at-the-time rule, only records after the move are shown. Earlier records stay with the {old} manager.",
  "people.d.disabled.title": "This person is deactivated",
  "people.d.disabled.body": "Sign-in and connection tokens are blocked. Records stay for the retention period.",
  "people.d.f.team": "Team",
  "people.d.f.manager": "Manager",
  "people.d.f.role": "Role",
  "people.d.f.level": "Recording level",
  "people.d.f.conn": "Connections",
  "people.d.f.last": "Last used",
  "people.d.f.job": "Job",
  "people.d.f.connLine": "{n|connection|connections} · {b} to check",
  "people.d.f.connOk": "{n|connection|connections} · all fine",
  "people.d.f.connNone": "No connections",
  "people.d.f.reconsent": "Consent renewal needed (based on {v})",
  "people.d.f.paused": "Paused ({from}–{to})",
  "people.d.f.noManager": "No manager assigned",
  "people.d.cli.q": "How much did they use CLI tools?",
  "people.d.cli.tech": "CLI tool · Claude Code · Codex",
  "people.d.cli.def": "Records from the AI coding tools Claude Code and Codex, whatever the payment method (subscription sign-in or API key).",
  "people.d.cli.sum": "Questions: {s}",
  "people.d.cli.sumOnly": "Sent {n|question|questions}.",
  "people.d.cli.empty": "No CLI tool records were received in this period.",
  "people.d.m.costCli": "Tool estimated cost",
  "people.d.m.calls": "Calls",
  "people.d.m.costApi": "Price-table cost",
  "people.d.m.latency": "Wait time",
  "people.d.latency": "typical {a} · slow {b}",
  "people.d.latA": "typical {a}",
  "people.d.latB": "slow {b}",
  "people.d.cli.sub": "Claude Code and Codex coding tools, whatever the payment method",
  "people.d.api.sub": "Calls apps and scripts made through the company gateway",
  "people.d.noTime": "AI active time and time of day aren’t shown per person (team totals only).",
  "people.d.noSum": "never added together",
  "people.d.auth": "Payment: subscription {s} · API key {k} · unknown {u}",
  "people.d.authNote": "By conversation · for Claude, the method last confirmed on each device",
  "people.d.gw": "CLI (via gateway) {n|call|calls} · checking duplicates",
  "people.d.gwHelp": "Not added to any card until we know the PC’s own records don’t include the same call. If they don’t, the calls join the totals after about 10 minutes.",
  "people.d.toolRow": "{p|question|questions} · {tok}",
  "people.d.toolRowApi": "{c|call|calls} · {tok}",
  "people.d.api.q": "How much did they call AI with API keys?",
  "people.d.api.tech": "API key call · company gateway",
  "people.d.api.def": "Calls apps and scripts made to AI through the company gateway. Only calls through the gateway are shown per person.",
  "people.d.api.sum": "Calls: {s}",
  "people.d.api.sumOnly": "Made {n|call|calls}.",
  "people.d.api.keys": "API keys they own",
  "people.d.api.noKeys": "They don’t own any API keys.",
  "people.d.api.org": "{k|key|keys} · {days|day|days} · usage {tok} · {usd}",
  "people.d.api.orgNote": "Keys they own · daily · not per person · not added to the numbers above",
  "people.d.api.empty": "No API key calls through the gateway.",
  "people.d.api.emptyNot": "Only calls through the gateway are shown per person. It doesn’t mean API keys weren’t used.",
  "people.d.daily.q": "How much did they use each day?",
  "people.d.daily.tech": "{metric} · stacked by how used · dashed = previous period",
  "people.d.daily.peak": "The busiest day was {day} ({v}).",
  "people.d.daily.peakWeek": "The busiest week was {day} ({v}).",
  "people.d.recent.q": "What were their recent conversations?",
  "people.d.recent.tech": "Conversations · latest {n} · other people’s records show by number only",
  "people.d.recent.sum": "The latest conversation started {rel}.",
  "people.d.recent.all": "Open in Activity",
  "people.d.col.title": "Conversation",
  "people.d.col.when": "Time",
  "people.d.col.tool": "Tool",
  "people.d.col.prompts": "Questions",
  "people.d.col.tokens": "Usage",
  "people.d.col.level": "Recording level",
  "people.d.col.peek": "First question",
  "people.d.peek": "View",
  "people.d.peekClose": "Close",
  "people.d.peekAria": "View the first question of conversation #{no}",
  "people.d.pv.title": "Conversation #{no} · first question",
  "people.d.pv.left": "{min} min left",
  "people.d.pv.noPerm": "This role can’t view this person’s question text. Managers can’t see teammates’ text by default.",
  "people.d.pv.flow": "Other people’s text opens only after a reason → re-sign-in → per-conversation grant (60 min), and the person is told.",
  "people.d.pv.own": "Your own record, so it opens right away.",
  "people.d.pv.empty": "This conversation has no question text (only commands).",
  "people.d.conn.q": "Are their tool connections OK?",
  "people.d.conn.tech": "Connection status · by last received",
  "people.d.conn.sumOk": "All {n|connection is|connections are} sending fine.",
  "people.d.conn.sumSome": "Check {bad} of {n|connection|connections}.",
  "people.d.conn.none": "No tools connected yet.",
  "people.d.conn.noneNot": "Nothing is recorded before connecting. Once connected, the next question is recorded.",
  "people.d.conn.ver": "CLI {v}",
  "people.d.conn.token": "Collect token {p}…",
  "people.d.conn.revoke": "Disconnect",
  "people.d.conn.revokeTitle": "Disconnect this tool?",
  "people.d.conn.revokeBody": "Revokes the {tool} collect token on {device}. Records from that PC are refused right away; using it again needs a new connection.",
  "people.d.conn.revoked": "Disconnected. Recorded in the access & change log.",
  "people.d.conn.scope": "They’re on another team now, so their connections aren’t shown.",
  "people.d.conn.at": "disconnected {date}",
  "people.d.role.q": "Which team and role do they have?",
  "people.d.role.tech": "Role & team · team history · team at the time",
  "people.d.role.sum": "{roles} on {team}.",
  "people.d.role.sumFormer": "Moved away from {team}. Their current role and connections are visible to the {now} manager and admins.",
  "people.d.role.grants": "Role grants",
  "people.d.role.g.role": "Role",
  "people.d.role.g.teams": "Teams",
  "people.d.role.g.at": "Granted",
  "people.d.role.g.by": "Granted by",
  "people.d.role.g.appr": "Approved by",
  "people.d.role.g.exp": "Expires",
  "people.d.role.g.base": "Base role everyone has",
  "people.d.role.g.all": "All",
  "people.d.role.g.none": "None",
  "people.d.role.g.never": "Not set",
  "people.d.role.hist": "Team history",
  "people.d.role.now": "now",
  "people.d.role.self": "You can’t change your own role or team. Ask another admin.",
  "people.d.role.pc": "Change roles and teams on a computer.",
  "people.d.role.system": "System",
  "people.d.aud.q": "Who viewed this person’s records?",
  "people.d.aud.tech": "Access & change log · text views, individual views, exports, deletion, legal hold · latest {n}",
  "people.d.aud.sum": "Of the latest {n}: {c} text views ({d} denied) · {p} individual views.",
  "people.d.aud.go": "Open the access & change log",
  "people.d.aud.note": "The person sees the viewer’s role, time and reason in “Who viewed my records”. Entries can’t be edited or deleted.",
  "people.d.aud.col.when": "Time",
  "people.d.aud.col.kind": "What",
  "people.d.aud.col.actor": "Who (role)",
  "people.d.aud.col.target": "Target & reason",
  "people.d.aud.col.result": "Result",
  "people.d.aud.conv": "Conversation #{no}",
  "people.d.aud.noReason": "No reason required",
  "people.d.aud.empty": "No one has opened this person’s records yet.",
  "people.d.aud.emptyNot": "Every opening is logged, whether allowed or denied.",
  "people.d.nf.title": "We can’t find this person",
  "people.d.nf.desc": "They don’t exist or are outside what your current role can view. Ask an admin if you need access.",
  "people.d.nf.back": "Back to People",
  "people.d.np.desc": "Person details need the “View individual details” permission. Your current role ({role}) can’t open them.",
};

export default people;
